// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyArzSNY6tOUgph-cw3k8dfAZ79LGgSLoVk",
  authDomain: "smart-chit-app.firebaseapp.com",
  projectId: "smart-chit-app",
  storageBucket: "smart-chit-app.appspot.com",
  messagingSenderId: "439775922695",
  appId: "1:439775922695:web:813b834dcabed488c2f8a2",
  measurementId: "G-40FXK1EBLJ",
};

// initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth with persistence
export const auth = getAuth(app);

// Firestore DB
export const db = getFirestore(app);

// (Optional) provider if using Google sign-in etc
export const googleProvider = new GoogleAuthProvider();
